(() => {
  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

  const applyClaims = () => {
    const engineProduct = document.querySelector('[data-kz-stage1], [data-kz-multiphase], [data-kz-stationary], [data-kz-motopump]');

    document.querySelectorAll('td, p, span, small, li').forEach((element) => {
      const text = element.textContent || '';
      if (/2\s*lata\s*lub\s*1000\s*motogodzin/i.test(text)) {
        element.innerHTML = element.innerHTML.replace(/2\s*lata\s*lub\s*1000\s*motogodzin/gi, '2 lata lub 500 motogodzin');
      }

      const normalized = normalize(text);
      if (normalized === 'norma euro v' || normalized === 'euro v' || normalized === 'eu stage v' || normalized === 'stage v') {
        const removable = element.closest('article, li, tr, .product-info__block-item') || element;
        removable.remove();
      }
    });

    if (engineProduct && !document.getElementById('kz-product-warranty')) {
      const note = document.createElement('div');
      note.id = 'kz-product-warranty';
      note.className = 'kz-product-warranty';
      note.innerHTML = '<strong>Gwarancja:</strong> 2 lata lub 500 motogodzin — w zależności od tego, co nastąpi wcześniej. Dotyczy klientów indywidualnych i firm.';
      const hero = engineProduct.querySelector('header') || engineProduct.firstElementChild;
      if (hero) hero.insertAdjacentElement('afterend', note);
      else engineProduct.prepend(note);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyClaims, { once: true });
  } else {
    applyClaims();
  }
})();
